import Text from 'components/ui/Text';
import useAppSelector from 'hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { selectWithdrawal } from 'store/reducers/withdrawalSlice';
import { WITHDRAWAL_ROUTES } from 'utils/withdrawalRoutes';
import { LineInfo, LineRow, SummaryRow } from './WithdrawalStyles';

// The on-screen acknowledgement of receipt. It shows only what the confirm response contains.
const WithdrawalSuccess = () => {
    const { t } = useTranslation();
    const { acknowledgement } = useAppSelector(selectWithdrawal);

    if (!acknowledgement) return <Navigate to={WITHDRAWAL_ROUTES.lookup} replace />;

    return (
        <div>
            <h1>{t('withdrawal_success_title')}</h1>
            <Text className="mb-2">{t('withdrawal_success_received')}</Text>
            <Text light className="mb-3">
                {t('withdrawal_success_not_approval')}
            </Text>

            <Text>{`${t('order_number')}: ${acknowledgement.orderNumber}`}</Text>
            <Text className="mb-2">{`${t('withdrawal_submitted_at')}: ${acknowledgement.submittedAtFormatted}`}</Text>

            <div>
                {acknowledgement.lines.map((line) => {
                    const details = [line.color, line.size, line.split].filter((part) => !!part).join(' / ');
                    return (
                        <LineRow key={line.lineId}>
                            <LineInfo>
                                <Text bold>{`${line.productName} × ${line.quantity}`}</Text>
                                {details && <Text light>{details}</Text>}
                            </LineInfo>
                            {line.lineTotalFormatted && <span>{line.lineTotalFormatted}</span>}
                        </LineRow>
                    );
                })}
            </div>

            {acknowledgement.indicativeTotalFormatted && (
                <SummaryRow className="mt-2">
                    <strong>{t('withdrawal_indicative_total')}</strong>
                    <strong>{acknowledgement.indicativeTotalFormatted}</strong>
                </SummaryRow>
            )}
        </div>
    );
};

export default WithdrawalSuccess;
